import { EventsState, eventsAdapter } from './events.interfaces';

export const eventsInitialState: EventsState = eventsAdapter.getInitialState({
  isLoading: false,
});
